export default __webpack_public_path__ + "static/media/signUpPaymentIcon.1ae5b7f4.svg";